import { createEntityAdapter } from '@reduxjs/toolkit';
import { CommunicationCampaignRevenueInDTO } from '../campaign.type';

export const notificationAdapter = createEntityAdapter<CommunicationCampaignRevenueInDTO>({});
